import { conditionsConstants } from '../constants'

const defaultState = {
    data: [{}],
  }

export default function conditions(state = defaultState, action){
    switch(action.type) {
        case conditionsConstants.CONDITIONS_SELECTED:
            return { ...state, ...action }
        default:
            return { ...state }
    }
}